module.exports = __webpack_public_path__ + "img/quill.b7352a18.svg";